import React from 'react';
import { number, bool, string } from 'prop-types';
import classNames from 'classnames';

import css from './CharacterCounter.module.css';

const CharacterCounter = ({ currentLength, maxLength, hasError, className }) => {
  return (
    <div
      className={classNames(css.characterCounter, className, {
        [css.counterError]: hasError,
      })}
    >
      {currentLength}/{maxLength}
    </div>
  );
};

CharacterCounter.defaultProps = {
  currentLength: 0,
  hasError: false,
  className: null,
};

CharacterCounter.propTypes = {
  currentLength: number,
  maxLength: number.isRequired,
  hasError: bool,
  className: string,
};

export default CharacterCounter;
